module.exports = __webpack_public_path__ + "4342045c2f2620c21499b816300e4a22.MP3";